import qs from 'qs';

import { numberWithTwoDecimals } from 'hb-react/shared/utils/formatNumber';

const displayAmount = (amount) => numberWithTwoDecimals(amount / 100);

const displayCurrency = (currency) =>
  typeof currency === 'string' ? currency : currency.code;

const cartItemWithRecurringPayment = (endpointData) =>
  endpointData({}).cart.cart_items.some((cartItem) => cartItem.recurring);

const getPaymentMethodsConfiguration = ({ paymentAccountConfig }) => {
  if (!paymentAccountConfig) {
    return {
      sepaDebitEnabled: false,
      idealEnabled: false,
      bancontactEnabled: false,
      onlyCreditCardEnabled: true,
    };
  }

  const sepaDebitEnabled = paymentAccountConfig.sepa_debit_enabled;
  const idealEnabled = paymentAccountConfig.ideal_enabled;
  const bancontactEnabled = paymentAccountConfig.bancontact_enabled;

  return {
    sepaDebitEnabled,
    idealEnabled,
    bancontactEnabled,
    onlyCreditCardEnabled:
      !sepaDebitEnabled && !idealEnabled && !bancontactEnabled,
  };
};

export {
  displayAmount,
  displayCurrency,
  getPaymentMethodsConfiguration,
  cartItemWithRecurringPayment,
};

export const getReturnUrl = (params = {}) => {
  const query = qs.parse(window.location.search, { ignoreQueryPrefix: true });

  const queryString = [
    qs.stringify(query, {
      filter: (k, v) => {
        if (
          [
            'cart_id',
            'payment_intent',
            'payment_intent_client_secret',
            'redirect_status',
            'source_type',
          ].includes(k)
        ) {
          return undefined;
        }

        return v;
      },
      encode: false,
    }),
    qs.stringify(params),
  ].join('&');

  return `${window.location.origin}${window.location.pathname}?${queryString}`;
};
